<template>
  <Modal title="最终意见" v-model="isShowModal" className="iv-review-result-modal" @on-ok="confirm" :readOnly="isReadOnly">
    <ModalLayout>
      <DragTable
        class="iv-m-t-12 iv-m-b-16"
        noSearch
        :showPage="false"
        :showEdit="false"
        :showDelete="false"
        :showSelect="false"
        ref="DragTable"
        :immediateForce="true" 
        :columns="allColumn"
        :tableData="allData">
      </DragTable>
      <DragTable
        class="iv-m-t-12 iv-p-b-12"
        noSearch
        :showPage="false"
        :showEdit="false"
        :showDelete="false"
        :showSelect="false"
        ref="DragTable1"
        :immediateForce="true" 
        :columns="singleColumn"
        :tableData="tableData">
      </DragTable>
      <div v-if="reviewGroupInfo.scoringMethod == 'DFFS03'">
        <p class="iv-m-b-8">最终定级</p>
        <Select v-model="finishRank" style="width:200px">
          <Option v-for="item in rankList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </div>
      <p class="iv-m-t-12 iv-m-b-8">最终意见</p>
      <Input class="iv-p-b-20" v-model="finishOpinion" type="textarea" :rows="4"></Input>
    </ModalLayout>
  </Modal>
</template>

<script>
import allColumn from './all-column'
import Modal from '@/components/modal'
import singleColumn from './single-column'
import ModalLayout from '@/components/modal/layout'
import DragTable from '@/components/drag-table-inline'
import {saveFinalInfo, getObjectScoreList} from '../../interface'

export default {
  props: {
    reviewGroupInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    dictCode: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isShowModal: false,
      dictMap: {},
      tableData: [],
      allData: [],
      finishOpinion: '', //最终意见
      finishRank: '',
      allColumn: [],
      singleColumn: [],
      rankList: [],
      reviewObjectId: '',
      isReadOnly: false
    }
  },
  methods: {
    open (info) {
      this.reviewObjectId = info.reviewObjectId
      this.finishOpinion = info.objectOpinion || ''
      this.finishRank = info.objectRank || ''
      this.isReadOnly = info.isReadOnly || false
      this.allColumn = allColumn.call(this)
      this.singleColumn = singleColumn.call(this)
      //只有定级的时候才去设置
      if (this.reviewGroupInfo.scoringMethod == 'DFFS03') {
        const rankObj = this.dictCode[this.reviewGroupInfo.scoreFieldDict]
        this.rankList = Object.keys(rankObj).map(item => ({
          label: rankObj[item],
          value: item
        }))
        this.setDynamicColumns(rankObj)
      }
      this.getUserReviewInfo(0)
      this.isShowModal = true
    },
    setDynamicColumns (rankObj) {
      this.allColumn.splice(1, 0, ...Object.keys(rankObj).map(item => {
        return {
          title: rankObj[item],
          [$field]: item
        }
      }))
    },
    getUserReviewInfo (index) {
      getObjectScoreList({reviewObjectId: this.reviewObjectId}).then(({data}) => {
        //获取这个项目总的轮次的情况
        this.allData = data.map(item => {
          if (item.rankList && item.rankList.length) {
            item.rankList.forEach(val => {
              if (!item[val.dataCode]) {
                item[val.dataCode] = val.dataNum
              }
            })
          }
          return item
        })
        //获取打分人在这一轮次的具体打分情况
        this.tableData = data[index].detailList.map(val => ({
          ...val,
          reviewRoundNum: data[index].reviewRoundNum
        }))
      })
    },
    confirm () {
      saveFinalInfo({finalDatas: [
        {
          reviewObjectId: this.reviewObjectId,
          objectRank: this.finishRank,
          objectOpinion: this.finishOpinion
        }
      ]}).then(({data}) => {
        this.$Message.success('提交成功')
        this.$emit('on-confirm')
        this.isShowModal = false
      })
    }
  },
  components: {
    Modal,
    DragTable,
    ModalLayout
  }
}
</script>
